import React from "react";
import Skeleton from "@mui/material/Skeleton";

export const PhotoSkeleton = () => {
  return (
        <Skeleton variant="rectangular" width="100%" height={200}  sx={{borderRadius:'15px'}} />
  );
};
